import { getTrackingData } from "./getTrackingData";

export const submitToHubSpot = async (fields, portalId, formId, context = {}) => {
  const trackingData = await getTrackingData(); // Fetch tracking data

  // Add initial landing page to fields
  fields.push({
    name: 'uc_initial_landing_page', // HubSpot field name
    value: trackingData.initialLandingPage,
  }, {
    name: 'submission_url', // HubSpot field name
    value: trackingData.pageUri,
  });

  console.log('fields', fields);

  const hubspotData = {
    fields: fields.map(({ name, value }) => ({ name, value })),
    context: {
      hutk: trackingData.hubspotutk,
      pageUri: trackingData.pageUri,
      pageName: document.title,
      ipAddress: trackingData.ipAddress,
      ...context,
    },
  };

  console.log('hubspotData:', hubspotData);

  const response = await fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(hubspotData),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    console.error('HubSpot error response:', error);
    throw new Error('HubSpot submission failed');
  }
};
